import ProductBadge from 'components/gruenland/atoms/badge/ProductBadge';
import { useFormat } from 'helpers/hooks/useFormat';

const OutOfStock: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return <ProductBadge>{formatMessage({ id: 'badges.outOfStock', defaultMessage: 'Non disponibile' })}</ProductBadge>;
};

export default OutOfStock;
